import React, {Component} from 'react';
import './PersonalInfo.css';
import {DatePicker, Form, Input, Select} from 'antd';
import {validateField} from "../../common/validation";

const { Option } = Select;

class PersonalInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name:"",
        };
        this.validateClass=this.validateClass.bind(this);
        this.validateMessage=this.validateMessage.bind(this);
        this.validateField=this.validateField.bind(this);
        this.checkComponentValidation=this.checkComponentValidation.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        console.log("mevcuthata ",error);
        this.props.validateStep("personalInfoError",error);
        this.checkComponentValidation(error);
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    checkComponentValidation() {
        let error = this.props.validationInfo.personalInfoError;
        console.log("currenterror",error);
        let valid=false;
        if ( ( error["tAd"] !== undefined) && ( error["tSoyad"] !== undefined ) && ( error["tTckNo"] !== undefined))
        {
            if (error["tAd"]["valid"] && error["tSoyad"]["valid"] && error["tTckNo"]["valid"]) {
                console.log("valid true");
                valid = true;
            }
        }
        this.props.validateStep("citySelectionValid",valid);
    }


    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 7 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
            },
        };


        console.log("this.props.memberInfo.dogumTarihi==>",this.props.memberInfo.dogumTarihi);
        const tDogumTarihi = this.props.memberInfo.dogumTarihi ? {value: this.props.memberInfo.dogumTarihi} : {};
        console.log("tDogumTarihi==>",tDogumTarihi);
        const tKimlikSonGecerlilikTarihi = this.props.memberInfo.kimlikSonGecerlilikTarihi ? {value:this.props.memberInfo.kimlikSonGecerlilikTarihi} : {};

        return (
            <div class="contactInfo-container ">
                <Form {...formItemLayout}>
                    <Form.Item label="Doğum Tarihi">
                        <DatePicker format= "DD.MM.YYYY" {...tDogumTarihi} placeholder="Tarih Seçiniz" style={{ width: '100%' }} onChange={(dateString)=>this.props.onInfoChange("dogumTarihi",dateString)}  />
                    </Form.Item>
                    <Form.Item
                        label="Baba Adı:">
                        <Input maxlength={25} value={this.props.memberInfo.babaAdi}  placeholder="Baba Adı" allowClear onChange={(e)=>this.props.onInfoChange("babaAdi",e.target.value)} />
                    </Form.Item>
                    <Form.Item
                        label="Ana Adı:">
                        <Input maxlength={25} value={this.props.memberInfo.anaAdi}  placeholder="Ana Adı" allowClear onChange={(e)=>this.props.onInfoChange("anaAdi",e.target.value)} />
                    </Form.Item>

                    <Form.Item
                        label="Kimlik Tipi:">
                        <Select placeholder="Seçiniz" value={this.props.memberInfo.kimlikTipi} style={{ width: 200 }} onChange={(value)=>this.props.onInfoChange("kimlikTipi",value)}>
                            <Option value="NufusCuzdani">Nüfus Cüzdanı</Option>
                            <Option value="TCKimlikKarti">TC Kimlik Kartı</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label='Kimlik Seri No:'>
                        <Input  maxlength={10} value={this.props.memberInfo.cuzdanKimlikSeriNo}  placeholder="Kimlik Seri No" allowClear onChange={(e)=>this.props.onInfoChange("cuzdanKimlikSeriNo",e.target.value)} />
                    </Form.Item>
                    {
                            (this.props.memberInfo.kimlikTipi==="NufusCuzdani")
                            ?
                        <Form.Item
                            label="Kimlik Kayıt No:">
                            <Input disabled={(this.props.memberInfo.kimlikTipi === "NufusCuzdani") ? false : true}
                                   maxlength={10} value={this.props.memberInfo.kayitNo}
                                   placeholder="Kimlik Kayıt No"
                                   allowClear
                                   onChange={(e) => this.props.onInfoChange("kayitNo", e.target.value)}/>
                        </Form.Item>
                    :
                        ""
                    }
                    {
                        (this.props.memberInfo.kimlikTipi==="TCKimlikKarti")
                        ?
                        <Form.Item
                            label="Kimlik Son Geçerlilik Tarihi">
                            <DatePicker
                                disabled={(this.props.memberInfo.kimlikTipi === "TCKimlikKarti") ? false : true}
                                format="DD.MM.YYYY" {...tKimlikSonGecerlilikTarihi}
                                placeholder="Tarih Seçiniz"
                                style={{width: '100%'}}
                                onChange={(dateString) => this.props.onInfoChange("kimlikSonGecerlilikTarihi", dateString)}/>
                        </Form.Item>
                        :
                        ""
                    }
                    <Form.Item
                        label="Doğum Yeri:">
                        <Input maxlength={50} value={this.props.memberInfo.dogumYeri} placeholder="Doğum Yeriniz" allowClear onChange={(e)=>this.props.onInfoChange("dogumYeri",e.target.value)} />
                    </Form.Item>
                    <Form.Item
                        label="Medeni Hal:">
                        <Select placeholder="Seçiniz" value={this.props.memberInfo.medeniHali} style={{ width: 120 }} onChange={(value)=>this.props.onInfoChange("medeniHali",value)}>
                            <Option value="BEKAR">BEKAR</Option>
                            <Option value="EVLI">EVLI</Option>
                            <Option value="EVLI">DUL</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Kan Grubu:">
                        <Input maxlength={10} value={this.props.memberInfo.kanGrubu} placeholder="Kan Grubunuz" allowClear onChange={(e)=>this.props.onInfoChange("kanGrubu",e.target.value)}/>
                    </Form.Item>

                </Form>
            </div>
        );
    }
}
export default PersonalInfo;



// WEBPACK FOOTER //
// ./src/page/personalInfo/PersonalInfo.js